<template>
  <div @mouseover="toggleMenu(false)" @mouseleave="toggleMenu(true)">
    <v-navigation-drawer
      id="core-navigation-drawer"
      fixed
      permanent
      app
      :mini-variant.sync="drawer"
      width="260"
    >
      <v-list class="mt-4">
        <v-img
                src="/assets/img/logo-long.png"
                height="50px"
                width="38px"
                class="mx-auto"
        />
      </v-list>
      <v-list expand nav class="px-0">
        <div />
        <template v-for="(item, i) in items">
          <SidebarBaseItem :key="`item-${i}`" :item="item" />
        </template>
        <div />
      </v-list>

      <template v-slot:append>
        <a class="btn-logout" @click="logout">
          <i class="fas fa-power-off"></i>
        </a>
      </template>
    </v-navigation-drawer>
  </div>
</template>

<script>
import SidebarBaseItem from "./SidebarBaseItem";
export default {
  name: "Sidebar",
  components: {
    SidebarBaseItem
  },
  props: {
    expandOnHover: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    drawer: true,
    items: [
      {
        icon: "far fa-newspaper",
        title: "Actualités",
        to: "/news"
      },
      // {
      //   icon: "far fa-newspaper",
      //   title: "Salon",
      //   to: "/salon"
      // },
      {
        icon: "far fa-clone",
        title: "Dossiers de Candidature",
        to: "/conseil-candidature"
      },
      {
        icon: "far fa-user",
        title: "Étudiants",
        to: "/etudiants"
      },
      {
        icon: "far fa-file-alt",
        title: "Spécialités",
        to: "/lumiere-specialite"
      },
      {
        icon: "far fa-comment-dots",
        title: "Conseil Orientation",
        to: "/conseil-orientation"
      },
      {
        icon: "far fa-bell",
        title: "Notification",
        to: "/notification"
      }
    ]
  }),
  methods: {
    async logout() {
      this.$store.dispatch("logout");
    },
    toggleMenu(status) {
      this.drawer = status;
    }
  }
};
</script>

<style lang="sass">
@import '~vuetify/src/styles/tools/_rtl.sass'

#core-navigation-drawer
    z-index: 100000
    background-color: #8E2569
    .v-list-item
        color: #fff !important
    .v-list-group__header.v-list-item--active:before
        opacity: .24

    .v-list-item
        &__icon--text,
        &__icon:first-child
            justify-content: center
            text-align: center
            width: 20px

            +ltr()
                margin-right: 24px
                margin-left: 12px !important

            +rtl()
                margin-left: 24px
                margin-right: 12px !important

    .v-list--dense
        .v-list-item
            &__icon--text,
            &__icon:first-child
                margin-top: 10px

    .v-list-group--sub-group
        .v-list-item
            +ltr()
                padding-left: 8px

            +rtl()
                padding-right: 8px

        .v-list-group__header
            +ltr()
                padding-right: 0

            +rtl()
                padding-right: 0

            .v-list-item__icon--text
                margin-top: 19px
                order: 0

            .v-list-group__header__prepend-icon
                order: 2

                +ltr()
                    margin-right: 8px

                +rtl()
                    margin-left: 8px
</style>
